import { handleCookiesChange } from './cookie-consent'
import { setAccessToken } from './token'

export const MESSAGE_TYPES = {
  SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
  POSTHOG_CONSENT: 'POSTHOG_CONSENT',
  POSTHOG_CAPTURE: 'POSTHOG_CAPTURE',
  FEATURE_FLAGS: 'FEATURE_FLAGS',
}

export const setupIframeMessageListener = () => {
  const handleMessage = (event) => {
    const message = event.data
    if (
      message?.type === MESSAGE_TYPES.SET_ACCESS_TOKEN &&
      message.payload?.token
    ) {
      setAccessToken(message.payload.token)
    }
    if (
      message?.type === MESSAGE_TYPES.POSTHOG_CONSENT &&
      message.payload?.ph_enabled
    ) {
      handleCookiesChange(message.payload.ph_enabled)
    }
    if (
      message?.type === MESSAGE_TYPES.FEATURE_FLAGS &&
      message.payload?.featureFlags
    ) {
      setFeatureFlags(message.payload.featureFlags)
    }
  }
  window.addEventListener('message', handleMessage)

  return () => window.removeEventListener('message', handleMessage)
}

export const capturePosthogEvent = (eventName, properties = {}) => {
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        type: MESSAGE_TYPES.POSTHOG_CAPTURE,
        payload: {
          eventName,
          properties,
        },
      },
      '*'
    )
  }
}

const setFeatureFlags = (featureFlags) => {
  localStorage.setItem('featureFlags', JSON.stringify(featureFlags))
}

export const getFeatureFlag = (flagName) => {
  const featureFlags = JSON.parse(localStorage.getItem('featureFlags') ?? '{}')
  return featureFlags[flagName] ?? false
}
